import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields, organizationClient, usernameClient } from "better-auth/client/plugins";

// Better Auth client for sign-in/up, invitations and member management.
// Same origin (/api/auth) so cookies never cross sites and no CORS is needed.
export const authClient = createAuthClient({
  baseURL: typeof window === "undefined" ? "http://localhost" : window.location.origin,
  basePath: "/api/auth",
  plugins: [
    organizationClient(),
    usernameClient(),
    // Mirrors control-api's user.additionalFields; web cannot import the server's auth type.
    inferAdditionalFields({ user: { locale: { type: "string", required: false }, appearance: { type: "string", required: false } } }),
  ],
});
